import React from "react"

function Ping() {
  return (
    <React.Fragment>
      <p>Pong!</p>
    </React.Fragment>
  )
}

export default Ping
